(function ($) {
    var MalinaGallery = function () {
        var
            gallery_id,
            photo_id,
            photo_date,
            photo_current = 0,
            photos_total,
            data,
            type,
            photo_size,
            photo_prefix,
            photo_buffer,
            photo_left,
            photo_right,
            slides_total,
            slide_position = 0,
            slide_holder,
            slide_left,
            slide_right,
            slide_width,
            slide_links,

            fetchData = function (callback) {
                ajax_call({
                        module:'Gallery',
                        action:'fetchData',
                        type:0,
                        args:{
                            'gid':gallery_id,
                            'size':photo_size
                        }
                    },
                    function (json) {
                        if (typeof(json.error) != 'undefined') {
                            $.facebox('<h2>Hups!</h2><br>Pri načítavaní fotografie sa vyskytla chyba nasledujúca chyba: <b>' + json.error + '</b>');
                            return;
                        }

                        photos_total = json.photos;
                        data = json.data;

                        jQuery.each(data, function (i, value) {
                            if (value.id == photo_id) {
                                photo_current = i;
                                return false;
                            }
                        });

                        callback();
                    },
                    'json');
            },
            loadPhoto = function () {
                photo = data[photo_current];
                photo_id = photo.id;

                $(photo_buffer).attr('src', photo.file);
                document.title = photo.name + ' - Fotodenník - TERAZ.sk';
                $("meta[property='og:title']").attr("content", photo.name);
                $("meta[property='og:url']").attr("content", "http://www.teraz.sk" + photo.link);
                $("meta[property='og:image']").attr("content", photo.file);
                $("meta[property='og:description']").attr("content", photo.desc);
            },
            changePhoto = function () {
                if (!data) {
                    fetchData(changePhoto);
                    return;
                }

                var i;
                for (i = 0; i < data.length; ++i) {
                    if (data[i].id == photo_id) {
                        photo_current = i;
                        break;
                    }
                }
                loadPhoto();
            },
            nextPhoto = function () {
                if (!data) {
                    fetchData(nextPhoto);
                    return;
                }

                photo_current = (photo_current + 1) % photos_total;
                $.address.value('fotodennik/fotografia/' + data[photo_current].id);
            },
            previousPhoto = function () {
                if (!data) {
                    fetchData(previousPhoto);
                    return;
                }

                photo_current = (photo_current - 1 + photos_total) % photos_total;
                $.address.value('fotodennik/fotografia/' + data[photo_current].id);
            },
            showPhoto = function () {
                console.log("showPhoto");
                $(photo_prefix + '_img').fadeOut('fast', function () {
                    $(photo_prefix + '_a').attr('href', photo.link);
                    $(photo_prefix + '_img').attr('src', photo.file);
                    $(photo_prefix + '_img').attr('alt', photo.name);
                    if (photo.desc) {
                        $(photo_prefix + '_desc').stop().html(photo.desc).css({'height':''}).attr("original_height", $(photo_prefix + '_desc').height());
                        $(photo_prefix + '_desc').stop().css({display:''}).animate({
                            height:$(photo_prefix + '_desc').attr("original_height"),
                            paddingTop:12,
                            paddingBottom:12
                        }, 'fast');
                        $(photo_prefix + '_photo').hover(descHoverOn, descHoverOut);
                    }
                    else {
                        $(photo_prefix + '_desc').stop().animate({
                            height:0,
                            paddingTop:0,
                            paddingBottom:0
                        }, 'fast');
                        $(photo_prefix + '_photo').off('hover');
                    }
                    if (photo_date) $(photo_date).html(photo.time_added + '<br />Zdroj: ' + photo.source);
                    $(photo_prefix + '_img').fadeIn('fast');
                    if (type == 'page') {
                        var new_slide_position = Math.floor(photo_current / 7);
                        if (slide_position != new_slide_position) {
                            slide_position = new_slide_position;
                            changeSlidePosition();
                        }
                    }
                });
            },
            changeSlidePosition = function () {
                $(slide_holder).stop().animate({
                    left:slide_width * -slide_position
                }, 'slow', 'easeInOutQuad');
            },
            nextSlides = function () {
                slide_position = (slide_position + 1) % slides_total;
                $.address.value('fotodennik/slide/' + slide_position);
            },
            previousSlides = function () {
                slide_position = (slide_position - 1 + slides_total) % slides_total;
                $.address.value('fotodennik/slide/' + slide_position);
            },
            descHoverOn = function () {
                $(photo_prefix + '_desc').stop().animate({
                    height:$(photo_prefix + '_desc').attr("original_height"),
                    paddingTop:12,
                    paddingBottom:12
                }, 'fast');
            },
            descHoverOut = function () {
                $(photo_prefix + '_desc').stop().animate({
                    height:0,
                    paddingTop:0,
                    paddingBottom:0
                }, 'fast');
            },
            init = function (options) {
                gallery_id = options.gallery;
                photo_id = options.photo;
                photo_date = options.photo_date;
                type = options.type;
                photo_size = options.size;
                photo_prefix = options.photo_prefix;
                photo_buffer = options.photo_buffer;
                photo_left = options.photo_left;
                photo_right = options.photo_right;
                slides_total = options.slides_total;
                slide_position = options.slide_position;
                slide_holder = options.slide_holder;
                slide_left = options.slide_left;
                slide_right = options.slide_right;
                slide_width = options.slide_width;
                slide_links = options.slide_links;

                $(photo_prefix + '_desc').each(function () {
                    $(this).attr("original_height", $(this).height());
                }).css({height:0, paddingTop:0, paddingBottom:0, overflow:'hidden'});

                if ($(photo_prefix + '_desc').html())
                    $(photo_prefix + '_photo').hover(descHoverOn, descHoverOut);

                if (photo_left) {
                    $(photo_left).click(function () {
                        previousPhoto();
                        return false;
                    });
                }

                if (photo_right) {
                    if (type == 'page') {
                        $(photo_right + ', ' + photo_prefix + '_a').click(function () {
                            nextPhoto();
                            return false;
                        });
                    }
                    else {
                        $(photo_right).click(function () {
                            nextPhoto();
                            return false;
                        });
                    }
                }

                if (slide_left) {
                    $(slide_left).click(function () {
                        previousSlides();
                        return false;
                    });
                }

                if (slide_right) {
                    $(slide_right).click(function () {
                        nextSlides();
                        return false;
                    });
                }

                if (slide_links) {
                    $(slide_links).click(function () {
                        photo_id = $(this).attr('href').match(/(\d+)-fotografia.html/)[1];
                        $.address.value('fotodennik/fotografia/' + photo_id);
                        return false;
                    });
                }

                if (photo_buffer) {
                    $(photo_buffer).bind('load', function () {
                        showPhoto();
                    });
                }

                if (type == 'page') {
                    $(window).on('keyup', function (event) {
                        switch (event.keyCode) {
                            case 37:
                                previousPhoto();
                                return false;
                            case 39:
                                nextPhoto();
                                return false;
                            default:
                                return true;
                        }
                    });
                }
            };

        return {
            bootstrap:function (param) {
                if (param.method == 'init') {
                    init(JSON.parse(param.data));
                    return;
                }
                if (param.method == 'next') {
                    nextPhoto();
                    return;
                }
                if (param.method == 'previous') {
                    previousPhoto();
                    return;
                }
                if (param.method == 'nextSlides') {
                    nextSlides();
                    return;
                }
                if (param.method == 'previousSlides') {
                    previousSlides();
                    return;
                }
                if (param.method == 'changePhoto') {
                    photo_id = param.photo_id;
                    changePhoto();
                    return;
                }
                if (param.method == 'changeSlidePosition') {
                    slide_position = param.slide_position;
                    changeSlidePosition();
                    return;
                }
            }
        };
    }();
    $.fn.MalinaGallery = MalinaGallery.bootstrap;
})(jQuery);